/* global $ */
import { initGoogleAuth } from './modules/googleAuth';
import { getTemplateJsContext } from './modules/helpers';
import { buttonLoading } from './modules/modals';

const signInButton = document.getElementById('gSignInButton');
const next = document.querySelector('[name=next]');

const templateJsContext = getTemplateJsContext();

initGoogleAuth(
  templateJsContext.googleClientId,
  signInButton,
  templateJsContext.loginWithSsoUrl,
  () => {
    const extraData = {};

    if (next && next.value) {
      extraData.next = next.value;
    }
    return extraData;
  },
  (errorResponse) => {
    if (errorResponse.responseJSON && errorResponse.responseJSON.error === 'not registered') {
      document.location.href = templateJsContext.notRegisteredUrl;
    } else {
      console.error('GoogleAuth Error', errorResponse);
    }
  }
);

$('#login-form').on('submit', function () {
  buttonLoading({ isLoading: true, button: $(this).find('button[type="submit"]') });
});
